import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { t } from '../../../../services/i18nService';
import selector from '../../../../services/RoomScanSelector';
import livestreamService from '../../../../services/livesession/LivestreamService';
import stateCacheService from '../../../../services/StateCache';
import navigationService from '../../../../services/NavigationService';

import PreCheckAction from '../preChecks/PreCheckAction';

import styles from '../../testOverview.scss';

class TestComponentRoomScan extends React.PureComponent {
    static propTypes = {
        showCompletionCheck: PropTypes.bool.isRequired,
        showOpenRoomScanButton: PropTypes.bool.isRequired,
    };

    openRoomScan = () => {
        navigationService.navigateToRoomScan();
    }

    render() {
        const { showCompletionCheck, showOpenRoomScanButton } = this.props;

        return (
            <PreCheckAction
                completed={showCompletionCheck}
                current={showOpenRoomScanButton}
                failed={false}
                title={t('roomScan.title')}
            >
                <button
                    className={`${styles.button} btn`}
                    onClick={this.openRoomScan}
                >
                    {t('roomScan.openRoomScan')}
                </button>
            </PreCheckAction>
        );
    }
}

function mapStateToProps(rootState) {
    const { idverification, livestream } = rootState;

    const state = {
        ...livestream,
        isHardwareAccessComponentCompleted: livestreamService.isCompleted(livestream),
        cachedIsRoomScanConfirmed: stateCacheService.getStateCacheInstance().isRoomScanConfirmed(),
    };

    return {
        showCompletionCheck: selector.isCompleted(
            state,
            idverification,
        ),
        showOpenRoomScanButton: selector.showOpenRoomScanButton(
            state,
            idverification,
        ),
    };
}

const TestComponentRoomScanContainer = connect(mapStateToProps)(TestComponentRoomScan);
export default TestComponentRoomScanContainer;
